export default "__VITE_ASSET__CccXv1IT__"